import { Component } from '@angular/core';
import { AuthenticationCtlService, UserControllerService } from '../api/services';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginDto } from '../api/models';
import { Router, RouterOutlet } from '@angular/router';

import { SessionService } from '../common/session.service';
import { MenuService } from '../common/menu.service';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-login',
    imports: [
    FormsModule,
    ReactiveFormsModule
],
    templateUrl: './login.component.html',
    styleUrl: './login.component.css'
})
export class LoginComponent {


     isVersusPay:boolean;
     clearPassword=false;
     message ='';
     loginForm = new FormGroup({
      username:new FormControl(),
      password: new FormControl()
    }
     );
  
  constructor(
    private loginService:AuthenticationCtlService,
    private session:SessionService,
    private userService:UserControllerService,
    private menuService :MenuService,
    private route :Router
  ){
    this.isVersusPay=environment.isVersusPay;

  }

  login(){
    console.log(this.loginForm.value);
    let dto:LoginDto = {
      username: this.loginForm.value.username,
      password:this.loginForm.value.password
    };
    this.loginService.login(dto)
    .subscribe({
      next:(resp)=>{
         let token = resp.token?resp.token:'';
         this.loadUser(token);
      },
      error:(err)=>{
        console.log(err);
        console.log('error login');
        console.log(err.status);
        if(err.status == 0){
          this.message ='Impossible d\'etablir la connexiion';
        }else if(err.status ==403||err.status ==401){
          this.message ='login ou mot de passe incorrecte';
        }
      }
    })
  }
  loadUser(token:string){

    this.session.setToken(token);
    this.userService.sessionUser().subscribe(
      {
        next:(resp)=>{
          console.log(resp);
          this.session.setSessionInfo(resp);
          if(resp.first){
            this.route.navigateByUrl('/password/change');
          }else {
          let profile = this.menuService.getMenu(resp.role?.code!!);
          console.log(profile);
          this.route.navigateByUrl(profile[0].link!!);
        }
        }
      })
    
  }
  onShowPassword(){
    console.log('show');
    this.clearPassword =!this.clearPassword;
    var pass = document.getElementById('password');
    if(this.clearPassword){
      pass?.setAttribute('type','text');
    }else{
      pass?.setAttribute('type','password');
    }
  }

}
